import React from 'react';

export const OutlinedArrowDown: React.FC<React.HTMLAttributes<SVGElement>> = (
  props
) => (
  <svg viewBox="2 2 12 12" {...props}>
    <path
      fill="currentColor"
      d="M8.357 10.866l4.495-4.083a.431.431 0 000-.649.54.54 0 00-.713 0L8 9.893 3.861 6.134a.541.541 0 00-.714 0 .431.431 0 000 .649l4.5 4.084a.547.547 0 00.71-.001z"
    />
  </svg>
);
